import React, { Fragment, useEffect, useState } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import Loader  from "~/components/loader"

import Security from "~/services/security";
import Survey   from "~/services/surveys";


const Pollfish = ({})=> {

  const currentUser = Security.currentUserValue;
  const apikey      = "87da5612-9436-4a60-b418-59eb936279ff";

  const [isLoading, setIsLoading] = useState(true);
  const [config, setConfig]       = useState({
    request_uuid : currentUser.id.toString(),
    api_key      : apikey,
    debug        : false,
    device_id    : currentUser.id.toString(),
    offerwall    : true,
    timestamp    : Date.now(),
    encryption   : "NONE",
    version      : 9,
  });

  useEffect(()=> {
    (async ()=> {
      document.body.style.overflow = "hidden";
      let info = (await Survey.pollfishInfo());
      setConfig(prev => ({...prev, ...info}));
      setIsLoading(false);
    })();
  }, [])

  return (
    <Fragment>
      <Backbar path="/surveys" />

      { isLoading ? <Loader type={19} center style={{marginTop: 150}} /> :
        <iframe
          width="100%"
          frameBorder="0"
          style={{height: "100vh", margin: 0, padding: 0, border: 0}}
          src={`https://wss.pollfish.com/v2/device/register/true?json=${JSON.stringify(config)}&dontencrypt=true&webplugin=true`}
        ></iframe> }

    </Fragment>
  );
};

export default Pollfish;
